"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _pageBreak = _interopRequireDefault(require("cccisd-icons/page-break"));
var _Player = _interopRequireDefault(require("./Player"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  code: 'pageBreak',
  name: 'Page break',
  icon: /*#__PURE__*/_react["default"].createElement(_pageBreak["default"], null),
  player: _Player["default"],
  isStaticPlayer: true,
  skipPlaying: true,
  previewButtons: ['delete']
};